module.exports = __webpack_public_path__ + "img/wenhua2.22c9756e.png";